import React from "react";
import { Eye } from "lucide-react";
import { scoreColor } from "../../lib/growth";

// How strong the branch looks to a prospective vendor.
export default function SellerImpression({ data, compact = false }) {
  if (!data) return null;
  const { score, label, summary, dimensions } = data;
  return (
    <div className="card p-6 sm:p-7 h-full" data-testid="seller-impression">
      <div className="flex items-center gap-2">
        <span className="grid place-items-center w-7 h-7 rounded-lg" style={{ background: "var(--grad-green-soft)" }}><Eye size={15} strokeWidth={2} color="#5F8213" /></span>
        <span className="label-caps">How strong do you look to a seller?</span>
      </div>
      <div className="flex items-end gap-3 mt-4">
        <div className="text-5xl font-extrabold tracking-tighter leading-none" style={{ color: scoreColor(score) }} data-testid="seller-score">{score}</div>
        <div className="text-lg font-semibold text-ink-3 mb-1">/ 100</div>
        <span className="ml-auto inline-flex items-center rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wider" style={{ background: "rgba(147,192,32,.14)", color: "#5F8213" }}>{label}</span>
      </div>
      <p className="text-sm text-ink-2 mt-4 leading-relaxed">{summary}</p>
      {!compact && dimensions && (
        <div className="mt-5 grid grid-cols-2 gap-x-6 gap-y-2.5">
          {dimensions.map((d) => (
            <div key={d.label} className="flex items-center gap-2" data-testid={`seller-dim-${d.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <span className="text-xs text-ink-2 truncate">{d.label}</span>
                  <span className="text-xs font-bold text-ink ml-2">{d.score}</span>
                </div>
                <div className="h-1.5 rounded-full mt-1" style={{ background: "#EDEEE9" }}>
                  <div className="h-full rounded-full" style={{ width: `${d.score}%`, background: scoreColor(d.score) }} />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
